module.exports = __webpack_public_path__ + "img/shrewd-save-1.413666c5.webp";